import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await axios.post(
          `${API}/api/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(res.data);
        navigate("/journal", { replace: true, state: { user: res.data } });
      } catch (err) {
        /* Auth callback failed — redirect to login */
        navigate("/auth", { replace: true });
      }
    };

    exchangeSession();
  }, [navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center" style={{ background: '#141210' }}>
      <div className="text-center">
        <p style={{ fontFamily: "'Playfair Display', serif", color: '#c4956a', fontSize: '1.5rem' }}>ECHO</p>
        <p className="mt-3 text-sm" style={{ color: '#9a9590' }}>Signing you in...</p>
      </div>
    </div>
  );
}
